import React from 'react'
import { Container, Col, Row, Image } from "react-bootstrap";
const ForThoseWhoServeUs = () => {
  return (
    <>
    <section className='cbr_serve'>
     <Container>
        <Row>
        <Col lg={8} md={12} sm={12} className='text-center m-auto'>
        <div className='cbr_diamond-elite'>
        <h2>For Those Who Serve Us</h2>
         <h4>Cultured Brilliance is proud to offer the Military and First Responders Diamond Elite Program 
            for active and retired United States military, police, fire and other rescue services personnel. 
            It is our small way of recognizing their contribution to the safety and well-being of our people every day.
         </h4>
         <br></br>
         <p>We want to make sure each member of this program has access to beautiful pieces they can be proud of and be able
             to give her the big look she never asked for, with a little cash left over for the other important things in life.
              Please enjoy these savings:</p>
              <ul className="listul">
                    <li>First time purchase:
                        <ul className="padd">
                            <li>engagement rings: 5% off center stone plus 10% off mounting OR</li>
                            <li>5% off in-store jewelry.</li>
                        </ul>
                    </li>
                    <li>Future Purchases: 5% off purchase <br></br>
                        <p>Diamond Elite discount is valid towards purchases as described here.
                             Not valid for previous purchases, gift certificates, repairs, or loose diamonds. 
                             Cannot be combined with other promotions or specials. Maximum discount with this program is $500. 
                             See store or contact us for details.

                        </p>
                    </li>
                </ul>
        </div>
        </Col>
        </Row>
     </Container>
    </section>
    </>
  )
}

export default ForThoseWhoServeUs
